import { useState } from "react";

export function useToggle(init = false) {
  const [value, setValue] = useState(init);

  return [value, () => setValue((v) => !v)] as const;
}
